import React, { Component } from 'react';
import { open } from './../libs/tabs.js';
import { setupJackpot } from './../casino/jackpot-render.js';

class LiveCasino extends Component {
	componentWillMount() {
		const sectionName = 'section4';
		setupJackpot(document.getElementById(sectionName));
		open(sectionName);
	}

	componentDidMount() {
		document.getElementsByClassName('content pusher')[0].scrollTop = 0;
	}

	render() {
		return false;
	}
}

export default LiveCasino;



// WEBPACK FOOTER //
// ./mobile-core/src/components/live-casino.js